export class ReviewSource {
  public name: string;
  public code: string;
  public industryId: number;
  public country: number;
}
